import bottom from './bottom'
import br from './br'
import bigoperation from './bigoperation'
import design from './design'
import online from './online'
import supply from './supply'
import digitalproduction_1 from './digitalproduction_1'
import production_schedule from './production_schedule'
import marketing from './marketing'
import quality_testing from './quality_testing'
import warehouse from './warehouse'
import digitalproduction_2 from './digitalproduction_2'
export default {
    bottom,
    br,
    bigoperation,
    design,
    online,
    supply,
    digitalproduction_1,
    production_schedule,
    marketing,
    quality_testing,
    warehouse,
    digitalproduction_2
}